
<div class="customDialog">
    <span class="customDialog_close" (click)="close()">
      <svg class="customDialog_iconClose c-icon">
        <use href="#ic-close"/>
      </svg>
    </span>

  <h2 mat-dialog-title class="m-titleSection--medium">{{ data.title }}</h2>
  <mat-dialog-content class="">
    <p class="m-titleSection--gris s-marginBottom-sml" [innerHTML]="data.textBody"></p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      class="m-button m-button--primary button_custom s-marginRight-md"
      [ngStyle]="{'background-color': data.btnLeftBgColor, 'color': data.btnLeftTextColor }"
      (click)="handleBtnLeft()"
      *ngIf="data.btnLeftText"
      >
      {{ data.btnLeftText }}
    </button>
    <button
      class="m-button button_custom"
      [ngStyle]="{'background-color': data.btnRightBgColor, 'color': data.btnRightTextColor }"
      (click)="handleBtnRight()"
      [disabled]="loading"
      cdkFocusInitial
      *ngIf="data.btnRightText">
      <mat-spinner [diameter]="14" *ngIf="loading">Loading</mat-spinner>
      <span class="s-marginLeft-xxs">{{ loading ? 'Lance...' : data.btnRightText }}</span>
    </button>
  </mat-dialog-actions>
</div>
